/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    console.log('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE mutation called with value:', value);
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) { state.bodyOverlay = val },
  UPDATE_PRIMARY_COLOR(state, val) { state.themePrimaryColor = val },
  UPDATE_THEME(state, val) { state.theme = val },
  UPDATE_WINDOW_WIDTH(state, width) { state.windowWidth = width },
  UPDATE_WINDOW_SCROLL_Y(state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // Projects
  // /////////////////////////////////////////////

  UPDATE_PROJECT(state, val) { 
    state.projectId = val;
    localStorage.setItem('selectedProjectId', val)
  },

  SET_AUTHORIZED_PROJECTS(state, projects) {
    state.authorizedProjects = projects.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    localStorage.setItem('projects', state.authorizedProjects);
    if (state.projectId === null) {
      state.projectId = state.authorizedProjects[0].id;
      localStorage.setItem('selectedProjectId', state.authorizedProjects[0].id);
    }
  },

  SET_CONFIGURATIONS(state, configurations) {
    state.powerbiConfigurations = configurations.powerbiConfigurations;
    state.activeDirectoryConfigurations = configurations.activeDirectoryConfigurations;
  },
  SET_APP_BOOTSTRAP_COMPLETED(state, isCompleted) {
    state.appBootstrapCompleted = isCompleted
  }
}

export default mutations

